// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// import template1 from "../../assets/resume1.svg";
// import template2 from "../../assets/resume2.svg";
// import template3 from "../../assets/resume3.svg";
// import template4 from "../../assets/resume4.svg";
// import template5 from "../../assets/resume5.svg";
// import template6 from "../../assets/resume6.svg";
// import template7 from "../../assets/resume7.svg";
// import template8 from "../../assets/resume8.jpeg";

// import bannerImg from "../../assets/cvtemplatebanner.png";

// export default function ResumeTemplates() {
//   const navigate = useNavigate();

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   const templates = [
//     { id: 1, img: template1, name: "Professional" },
//     { id: 2, img: template2, name: "Modern" },
//     { id: 3, img: template3, name: "Minimal" },
//     { id: 4, img: template4, name: "Creative" },
//     { id: 5, img: template5, name: "Simple" },
//     { id: 6, img: template6, name: "Classic" },
//     { id: 7, img: template7, name: "Elegant" },
//     { id: 8, img: template8, name: "Bold" },
//   ];

//   const handleTemplateSelect = (templateId) => {
//     navigate(`/resume-editor?template=${templateId}`);
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       <div className="mx-auto mt-20 sm:mt-20">

//         {/* Banner Section */}
//         <section className="w-full bg-[#97C0FF] bg-opacity-30">
//           <div className="max-w-6xl mx-auto px-4">
//             <div className="flex flex-col md:flex-row items-center justify-between gap-6 py-8 md:py-10">

//               {/* Left Content */}
//               <div className="flex-1">
//                 <h1 className="text-2xl md:text-3xl font-bold text-gray-700 mb-2">
//                   Free Resume Templates
//                 </h1>
//                 <p className="text-sm md:text-base font-medium text-gray-500 max-w-xl">
//                   Choose from professionally designed, ATS-friendly resume templates.
//                   Create a resume that helps you get hired faster.
//                 </p>
//               </div>

//               {/* Right Image */}
//               <div className="flex-1 flex justify-center md:justify-end">
//                 <img
//                   src={bannerImg}
//                   alt="Resume Illustration"
//                   className="max-h-[180px] md:max-h-[220px] w-auto object-contain"
//                 />
//               </div>

//             </div>
//           </div>
//         </section>

//         {/* Templates Grid */}
//         <section className="max-w-6xl mx-auto px-4 py-12 md:py-14">
//           <h2 className="text-lg md:text-xl font-semibold text-gray-700 mb-6">
//             Resume Templates
//           </h2>

//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
//             {templates.map((template) => (
//               <div
//                 key={template.id}
//                 onClick={() => handleTemplateSelect(template.id)}
//                 className="rounded-xl border border-gray-200 overflow-hidden
//                   hover:shadow-lg transition-all duration-300 cursor-pointer bg-white
//                   hover:-translate-y-1"
//               >
//                 <img
//                   src={template.img}
//                   alt={template.name}
//                   className="w-full h-[420px] object-contain bg-gray-50"
//                 />

//                 <div className="p-3 text-center">
//                   <p className="text-sm font-medium text-gray-600">
//                     {template.name}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//       </div>
//     </div>
//   );
// }





import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import template1 from "../../assets/resume1.svg";
import template2 from "../../assets/resume2.svg";
import template3 from "../../assets/resume3.svg";
import template4 from "../../assets/resume4.svg";
import template5 from "../../assets/resume5.svg";
import template6 from "../../assets/resume6.svg";
import template7 from "../../assets/resume7.svg";
import template8 from "../../assets/resume8.jpeg";
import bannerImg from "../../assets/cvtemplatebanner.png";

const TEMPLATES = [
  { id: 1, img: template1, name: "Professional", category: "Professional", popular: false },
  { id: 2, img: template2, name: "Modern",        category: "Modern",       popular: false },
  { id: 3, img: template3, name: "Minimal",       category: "Minimal",      popular: false },
  { id: 4, img: template4, name: "Creative",      category: "Creative",     popular: false },
  { id: 5, img: template5, name: "Simple",        category: "Minimal",      popular: false },
  { id: 6, img: template6, name: "Classic",       category: "Professional", popular: true  },
  { id: 7, img: template7, name: "Elegant",       category: "Modern",       popular: false },
  { id: 8, img: template8, name: "Bold",          category: "Creative",     popular: false },
];

const FILTERS = ["All", "Professional", "Modern", "Minimal", "Creative"];

const TRUST_BADGES = [
  {
    label: "ATS Optimized",
    icon: (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    label: "Instant PDF Download",
    icon: (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    label: "4.8 / 5 Rating",
    icon: (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
  },
  {
    label: "No Sign-up Required",
    icon: (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    ),
  },
  {
    label: "Ready in 5 Minutes",
    icon: (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
      </svg>
    ),
  },
];

export default function ResumeTemplates() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const filtered = activeFilter === "All"
    ? TEMPLATES
    : TEMPLATES.filter((t) => t.category === activeFilter);

  const handleTemplateSelect = (templateId) => {
    navigate(`/resume-editor?template=${templateId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto mt-20 sm:mt-20">

        {/* ── Hero Banner ── */}
        <section className="w-full bg-gradient-to-r from-blue-900 to-blue-600">
          <div className="max-w-6xl mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 py-10 md:py-12">

              {/* Left */}
              <div className="flex-1">
                <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
                  Free Resume Templates
                </h1>
                <p className="text-sm md:text-base text-blue-200 max-w-lg leading-relaxed">
                  Professionally designed, ATS-optimized templates. Pick a style,
                  fill in your details, and download your resume in minutes.
                </p>
              </div>

              {/* Stats + image */}
              <div className="flex items-center gap-8">
                {/* Stat cards */}
                <div className="flex gap-4">
                  {[
                    { value: "500K+", label: "Resumes created" },
                    { value: "8",     label: "Templates"       },
                    { value: "Free",  label: "Always"          },
                  ].map(({ value, label }) => (
                    <div
                      key={label}
                      className="bg-white/10 border border-white/20 rounded-xl
                        px-4 py-3 text-center"
                    >
                      <p className="text-xl font-bold text-white">{value}</p>
                      <p className="text-xs text-blue-200 mt-0.5">{label}</p>
                    </div>
                  ))}
                </div>

                {/* Banner image */}
                <img
                  src={bannerImg}
                  alt="Resume Illustration"
                  className="hidden md:block max-h-[140px] w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ── ATS Explanation Strip ── */}
        <div className="w-full bg-blue-50 border-b border-blue-100">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-start gap-2">
            <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <p className="text-xs text-blue-700 leading-relaxed">
              <span className="font-semibold text-blue-900">ATS-optimized:</span>{" "}
              All templates are tested against major Applicant Tracking Systems so your resume
              passes automated screening and reaches real hiring managers.
            </p>
          </div>
        </div>

        {/* ── Trust Badges Row ── */}
        <div className="w-full bg-white border-b border-gray-100 shadow-sm">
          <div className="max-w-6xl mx-auto px-4 py-3 flex flex-wrap gap-5 items-center">
            {TRUST_BADGES.map(({ label, icon }) => (
              <div key={label} className="flex items-center gap-1.5 text-xs font-medium text-gray-600">
                {icon}
                {label}
              </div>
            ))}
          </div>
        </div>

        {/* ── Templates Grid ── */}
        <section className="max-w-6xl mx-auto px-4 py-10 md:py-12">

          {/* Filter bar */}
          <div className="flex items-center gap-2 flex-wrap mb-6">
            <span className="text-sm text-gray-400 font-medium mr-1">Filter:</span>
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setActiveFilter(f)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all
                  ${activeFilter === f
                    ? "bg-blue-600 text-white border-blue-600"
                    : "bg-white text-gray-500 border-gray-200 hover:border-blue-400 hover:text-blue-600"
                  }`}
              >
                {f}
              </button>
            ))}
          </div>

          {/* Section header */}
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-semibold text-gray-700">Resume Templates</h2>
            <span className="text-sm text-gray-400">{filtered.length} templates</span>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filtered.map((template) => (
              <div
                key={template.id}
                onClick={() => handleTemplateSelect(template.id)}
                className={`relative rounded-xl overflow-hidden cursor-pointer
                  bg-white transition-all duration-300 hover:-translate-y-1
                  ${template.popular
                    ? "border-2 border-blue-600 shadow-lg"
                    : "border border-gray-200 hover:shadow-md hover:border-blue-400"
                  }`}
              >
                {/* Popular badge */}
                {template.popular && (
                  <div className="absolute top-2 left-2 z-10 bg-blue-600 text-white
                    text-[10px] font-bold px-2 py-0.5 rounded-md tracking-wide">
                    Popular
                  </div>
                )}

                {/* Template image */}
                <img
                  src={template.img}
                  alt={template.name}
                  className="w-full h-[380px] object-contain bg-gray-50"
                />

                {/* Footer */}
                <div className="p-3 border-t border-gray-100 flex items-center justify-between">
                  <p className={`text-sm font-medium
                    ${template.popular ? "text-blue-600" : "text-gray-600"}`}>
                    {template.name}
                  </p>
                  <span className="text-xs text-blue-600 font-semibold">Use this</span>
                </div>
              </div>
            ))}
          </div>
        </section>

      </div>
    </div>
  );
}
